var $10c0c6b39ed358cb$exports = {};
$10c0c6b39ed358cb$exports = {
    "more": `Flere elementer`
};


export {$10c0c6b39ed358cb$exports as default};
//# sourceMappingURL=da-DK.mjs.map
